
import { defineComponent, onBeforeMount, ref } from 'vue';
import axios, { AxiosError } from 'axios';
import { updateLearnerRecord } from '@/utils/admin/operation_service';
import { getTaskById, getPreSignedUrl, uploadSubmission } from '../../utils/learner_submit_service';

import ErrorMessage from '../../components/global/ErrorMessage.vue';

export default defineComponent({
  name: 'UpdateSubmission',
  components: { ErrorMessage },
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const taskId = ref(props.query.linked_task_id);
    console.log('Task ID', taskId.value);
    const learnerTaskId = ref(props.query.learner_task_id);
    const taskType = ref();
    const fileValidationMsg = ref();
    const learnerSubmission = ref();
    const learnerSubmissionFile = ref(null);
    const preSignedUrl = ref();
    const buttonDisable = ref(true);
    const validationError = ref();
    const fileInputKey = ref(0);
    const renderReady = ref(false);
    const errorResponse = ref();
    const showSuccessMessage = ref(false);
    const resMessage = ref();
    const showErrorMessage = ref(false);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectedFile = async (event: any) => {
      try {
        // eslint-disable-next-line prefer-destructuring
        learnerSubmissionFile.value = event.target.files[0];
        learnerSubmission.value = event.target.files[0].name;
        const fileSize = event.target.files[0].size / 1024 / 1024;

        if (fileSize > 200) {
          fileValidationMsg.value = 'fileSize greater than 200 MB';
        }
      } catch (error) {
        console.log(error);
        renderReady.value = true;
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          errorResponse.value = (err.response?.data as { message: string })?.message;
        } else {
          errorResponse.value = 'Something went wrong, please contact helpmate.';
        }
        showErrorMessage.value = true;
      }
    };
    const submitSubmiision = async () => {
      try {
        renderReady.value = false;
        if (!learnerSubmission.value) {
          if (taskType.value === 'Mobile') {
            renderReady.value = true;
            if (!learnerSubmission.value) {
              fileValidationMsg.value = 'please Enter Submission';
              console.log('inside Mobile Type');
              setTimeout(() => {
                fileValidationMsg.value = null;
              }, 6000);
            }
          } else if (taskType.value === 'Desktop') {
            renderReady.value = true;
            console.log(`learnerSubmission.value ${learnerSubmission.value}`);
            if (!learnerSubmission.value) {
              fileValidationMsg.value = 'please select File';
              setTimeout(() => {
                fileValidationMsg.value = null;
              }, 6000);
            }
          }
        } else {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          let invokeUpdateLearner: any;
          const data = {
            learner_task_id: learnerTaskId.value,
            learner_submission: learnerSubmission.value,
            taskType: taskType.value,
          };
          if (taskType.value === 'Desktop') {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const resPresSigned: any = await getPreSignedUrl('/v1/pretAuthUrlForUploadLearner', {
              file_name: learnerSubmission.value,
              learner_task_id: learnerTaskId.value,
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const preSignedRes: any = resPresSigned.data;
            preSignedUrl.value = preSignedRes.preSignedUrl;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const uploadedRes: any = await uploadSubmission(preSignedUrl.value, learnerSubmissionFile.value);
            if (uploadedRes.status === 200) {
              invokeUpdateLearner = await updateLearnerRecord('/uploadLearnerSubmissionFromAdmin', data);
            } else {
              renderReady.value = true;
              errorResponse.value = 'There is issue in the file upload, please contact with helpmate.';
              showErrorMessage.value = true;
            }
          } else {
            invokeUpdateLearner = await updateLearnerRecord('/uploadLearnerSubmissionFromAdmin', data);
          }
          if (invokeUpdateLearner.status === 200) {
            renderReady.value = true;
            resMessage.value = invokeUpdateLearner.data.message;
            showSuccessMessage.value = true;
            setTimeout(() => {
              resMessage.value = null;
              showSuccessMessage.value = false;
            }, 6000);
          } else {
            renderReady.value = true;
            errorResponse.value = 'There is some issue while submitting learner submission, please contact with helpmate.';
            showErrorMessage.value = true;
            setTimeout(() => {
              resMessage.value = null;
              showSuccessMessage.value = false;
            }, 6000);
          }
        }
      } catch (error) {
        renderReady.value = true;
        console.log(`error ${error}`);
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          errorResponse.value = (err.response?.data as { message: string })?.message;
        } else {
          errorResponse.value = 'There is some issue while submitting learner submission, please contact with helpmate.';
        }
        showErrorMessage.value = true;
      }
    };
    const getTaskdetails = async () => {
      renderReady.value = false;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const res: any = await getTaskById(taskId.value);
      console.log(`task data ${JSON.stringify(res)}`);
      const taskRes = res.data.data;
      if (taskRes) {
        taskType.value = taskRes.task_type;
      } else {
        errorResponse.value = 'There is an issue to fetch task, please contact helpmate.';
        showErrorMessage.value = true;
      }
      renderReady.value = true;
    };

    onBeforeMount(async () => {
      await getTaskdetails();
    });
    return {
      taskType,
      learnerTaskId,
      renderReady,
      errorResponse,
      showErrorMessage,
      showSuccessMessage,
      resMessage,
      fileValidationMsg,
      submitSubmiision,
      learnerSubmission,
      selectedFile,
      preSignedUrl,
      buttonDisable,
      validationError,
      fileInputKey,
    };
  },
});
